import React from "react";
import Navbar from "../Components/Navbar";
import subpagebanner from "../Assets/subpagebanner.png";
import footer from "../Assets/footer.png";
import Poster from "../Components/Posters.jsx";

const About = () => {
  return (
    <div className="App">
      <div className="home-container">
        <Navbar />
        <img src={subpagebanner} alt="" />
      </div>
      <div className="bodycopy-container">
        <h1 className="secondary-heading">Public Voting</h1>
        <br />
        <h2>
          Congratulations to the 50 lucky winners of the NUS - Guru Network AI
          Innovation Challenge 2025!
        </h2>
        <br />
        <ol>
          <li>Joshua Wee Aik Liang</li>
          <li>Hui Yun</li>
          <li>Tan Wei Xian</li>
          <li>Ang Wee Suan</li>
          <li>Nur Laiyinah</li>
          <li>Cindy Tan</li>
          <li>Neo Kim Han</li>
          <li>Chong Jia Hao</li>
          <li>Ryan Chua Zong Xun</li>
          <li>Usman Manazir</li>
          <li>Judith Or</li>
          <li>Yeo Kaizong Amos</li>
          <li>Chan Kai Fung</li>
          <li>Sophia Chua</li>
          <li>Eliz Ng</li>
          <li>Toh Zhen Wei</li>
          <li>Sole Song</li>
          <li>Jared Tan</li>
          <li>Rumesh Sree Krishnasamy Gnanavel</li>
          <li>Wong Shi Hui</li>
          <li>Taylor Susan</li>
          <li>Chan Yew Cheong</li>
          <li>Shen Liezhou</li>
          <li>Vadlamudi Saisindhu</li>
          <li>Yu Tao</li>
          <li>Zaccheus Tan</li>
          <li>Priya Chaudhari</li>
          <li>Yan Renyu</li>
          <li>Benjamin Tay</li>
          <li>Shanice Tham Jie Ying</li>
          <li>Liang Yuxin</li>
          <li>Charlotte low</li>
          <li>Karen Ang</li>
          <li>Tiffany Lam</li>
          <li>Minn Khant Kyaw</li>
          <li>Suvarna Gatik Santhosh</li>
          <li>Zhou Jianghui</li>
          <li>Shikhar Gupta</li>
          <li>Soniyya Senthiyl</li>
          <li>Teo Zhi Xian</li>
          <li>Tan Koh Nie</li>
          <li>Chen Junyu</li>
          <li>Gladia Hotan</li>
          <li>David Wee Wah Seow</li>
          <li>Sally Tay</li>
          <li>Lee Sek Hao</li>
          <li>Wu Ziye</li>
          <li>Norman sim kah wee</li>
          <li>Ho Yan Ying</li>
          <li>Wong Jing Ru</li>
        </ol>
        <br />
        <br />

        <h3>Note:</h3>
        <ol>
          <li>
            Winners will be contacted via the email addresses provided during
            submission.
          </li>
          <li>
            The organiser will contact the winners within the first two weeks
            after the Final Day Presentation.
          </li>
          <li>
            Please note that if any winner is uncontactable or if the prizes are
            not collected by 31 July 2025, the organising committee reserves the
            right to handle any unclaimed prizes at NUS’s discretion.
          </li>
          <li>
            Winners who violate the terms and conditions will be disqualified.
          </li>
        </ol>
        <br />
        <p>
          Refer to the{" "}
          <a href="https://drive.google.com/file/d/1VTK-1TMwAchhWg1rGsD-8KZCQ9q9Hzcm/view?usp=sharing">
            Terms and Conditions 
          </a>
          for details on the voting process.
        </p>
        <br />
        <br />
        <br />

        {/*
        <h3 className="center-text">
          Support your favorite team in the NUS - Guru Network AI Innovation
          Challenge 2025! Public voting contributes 10% of the final score, so
          your vote can help determine the winner. 50 lucky winners will win a
          $100 Grab voucher just by voting!
        </h3>
        <br />
        <br />
        <h2>Voting:</h2>
        <div class="subheader-style"></div>
        <p>Vote for your preferred team and help determine the winner!</p>
        <p>Voting opens on: 15 Mar 2025, 12:00 a.m. (GMT+8)</p>
        Voting closes on: 18 March 2025, 11:59 p.m. (GMT+8)
        <br />
        {/*
        <a href="">
          <button className="primary-button">Vote Now!</button>
          
        </a>
        */}
        <br />

        <br />
        {/*
        <h2>Public Voting Rules:</h2>
        <div class="subheader-style"></div>
        <br />
        <p>
          1.      Voting Process: The public is invited to vote for their
          favourite team’s solution.
          <br />
          <br />
          2.      Only votes for teams that make it to the Top 8 will be
          eligible for the lucky draw.
          <br />
          <br />
          3.      Each participant is allowed one vote. Multiple votes from the
          same participant will result in disqualification.
          <br />
          <br />
          4.      Members of participating teams are not permitted to vote.
          <br />
          <br />
          5.      50 lucky winners will each receive a $100 Grab voucher.
          <br />
          <br />
          6.      The $100 Grab voucher cannot be exchanged for cash or any
          other prizes.
          <br />
          <br />
          7.      The organiser's decision is final with regards to the public
          voting.
        </p>

        <h2>View Team Posters</h2>
        <div class="subheader-style"></div>
        <p>
          View the participating teams’ posters in the gallery below or visit
          this link:{" "}
          <a href="https://drive.google.com/drive/folders/1EYmUGh9acmrngUqtEhBi3bOI8bgPMIa-?usp=sharing">
            Teams' Posters in PDF
          </a>
        </p>
        <br />
        <Poster />
        */}
        <br />
        <br />
        <br />
        <img src={footer} alt="" />
      </div>
    </div>
  );
};
export default About;
